import * as yup from 'yup';
import { yupRequiredNonEmptyString } from '../utils/yupRequiredNonEmptyString';

export enum UploadType {
  BAG = 'bag',
  COLLECTION_JSON = 'collection.json',
}

export const UploadSchema = yup.object().shape({
  id: yupRequiredNonEmptyString('ID'),
  collectionID: yupRequiredNonEmptyString('Collection ID'),
  uri: yupRequiredNonEmptyString('URI'),
  fileName: yupRequiredNonEmptyString('File name'),
  size: yup
    .number()
    .required('Size is required')
    .transform((value) => (value === '' || isNaN(value) ? null : value))
    .typeError('Size must be a number')
    .min(1, 'Size cannot be zero'),
  deviceID: yupRequiredNonEmptyString('Device ID'),
  uploadedAt: yupRequiredNonEmptyString('Upload date'),
  type: yup
    .string()
    .oneOf(Object.values(UploadType), 'Invalid upload type')
    .required('Upload type is required'),
  fromDate: yupRequiredNonEmptyString('From date'),
  thruDate: yup.string().nullable(),
});

export type Upload = yup.InferType<typeof UploadSchema>;
